/**
 * No.9 (B)：問合せの3画面（一覧／新規／詳細）は申請者と代行者で同じコンポーネントを使い、
 * 呼ぶ API と遷移先ルートだけを切り替える。その切り替えを1箇所に集約する。
 *
 * 判定は $route.meta.page。代行者ルートは router で meta.page='agent' を宣言済みで、
 * ルーターガード（USER_META によるページ許可）も同じ軸で振り分けているため、
 * ガードが通した画面と画面自身の判定が食い違わない。
 *
 * ※ グローバル mixin にはしない。使う画面が明示的に import する。
 */
const ROUTE_NAMES = {
  gas: {
    top: 'gasTop',
    list: 'gasInquiryList',
    form: 'gasInquiryForm',
    detail: 'gasInquiryDetail',
  },
  agent: {
    top: 'agentTop',
    list: 'agentInquiryList',
    form: 'agentInquiryForm',
    detail: 'agentInquiryDetail',
  },
};

const API_BASE = {
  gas: '/api/inquiry',
  agent: '/api/agent/inquiry',
};

export default {
  computed: {
    // 代行者ページとして描画されているか
    isAgentPage() {
      return this.$route.meta.page === 'agent';
    },
    // 問合せ API のベースパス（申請者 /api/inquiry ／代行者 /api/agent/inquiry）
    inquiryApiBase() {
      return this.isAgentPage ? API_BASE.agent : API_BASE.gas;
    },
    // 遷移先のルート名（トップ／一覧／新規／詳細）
    routeNames() {
      return this.isAgentPage ? ROUTE_NAMES.agent : ROUTE_NAMES.gas;
    },
  },
};
